var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackoverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Stack Overflow",
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#f58025"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 30,
    fill: "none",
    d: "M293 89l90 120zm-53 50l115 97zm-41 65l136 64zm-23 69l148 31zm-6 68h150zm-45-44v105h241V297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackoverflow);
export default __webpack_public_path__ + "static/media/stackoverflow.567355c22d4fd6952f5440c47264fa60.svg";
export { ForwardRef as ReactComponent };